// PageVideoStreamingWarning.jsx

import React from 'react';

// CSS
import './PageVideoStreamingWarning.css';

/**
 * PageVideoStreamingWarning
 *
 * Non-blocking warning when a public page without a PIN contains video blocks.
 *
 * @returns {ReactNode} The rendered component.
 */
const PageVideoStreamingWarning = React.memo(({ onDismiss = null }) => {

  // ----- RENDER ----- //

  return (
    <div
      className="page-video-streaming-warning"
    >

      {/* COPY */}
      <div className="page-video-streaming-warning-copy">
        <strong>Public streaming:</strong>
        {' '}
        Videos on this page can be watched by anyone with the link. Streaming uses your space bandwidth. Consider setting a PIN in page settings to limit access.
      </div>

      {/* DISMISS */}
      {typeof onDismiss === 'function' ? (
        <button
          className="page-video-streaming-warning-dismiss"
          type="button"
          onClick={onDismiss}
        >
          Dismiss
        </button>
      ) : null}
    </div>
  );
});

// Dev Tools
PageVideoStreamingWarning.displayName = 'PageVideoStreamingWarning';

export default PageVideoStreamingWarning;
